import { apiRequest } from './index';

export const previewLeaveRequest = (data, success, failure) => apiRequest(
    '/forms/leave-preview',
    { method: 'POST', body: JSON.stringify(data) },
    success,
    failure,
);

export const fetchFormRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/forms/' + id, {}, success, failure);
}

export const fetchFormsRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/forms', {}, success, failure);
}

export const fetchFormsByEmployeeRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/forms/by-employee/' + id, {}, success, failure);
}

export const fetchPendingFormsRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/forms/pending', {}, success, failure);
}

export const countPendingFormsRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/forms/pending/count', {}, success, failure);
}

export const createFormRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/forms',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editFormRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/forms/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const deleteFormRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/forms/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}

export const handleFormApprovalRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/forms/approval/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}
